import React from 'react';
import { Link } from 'react-router-dom';

const WebDevelopment = () => {
    const services = [
        {
            icon: '🎨',
            title: 'Custom Website Design',
            description: 'Beautiful, responsive websites tailored to your brand and business goals.'
        },
        {
            icon: '🛒',
            title: 'E-Commerce Solutions',
            description: 'Full-featured online stores with secure payment processing and inventory management.'
        },
        {
            icon: '⚡',
            title: 'Web Applications',
            description: 'Complex, interactive web applications built with modern frameworks and technologies.'
        },
        {
            icon: '🔧',
            title: 'Website Maintenance',
            description: 'Ongoing support, updates, and optimization to keep your site running smoothly.'
        }
    ];

    const workProcess = [
        {
            step: '01',
            title: 'Discovery',
            description: 'We learn about your business, goals, and target audience to create a tailored strategy.'
        },
        {
            step: '02',
            title: 'Design',
            description: 'Our designers create stunning mockups and prototypes for your approval.'
        },
        {
            step: '03',
            title: 'Development',
            description: 'We build your website using modern, scalable technologies and best practices.'
        },
        {
            step: '04',
            title: 'Launch & Support',
            description: 'We deploy your site and provide ongoing support to ensure continued success.'
        }
    ];

    return (
        <div className="page">
            {/* Hero Section */}
            <section
                className="page-hero-side-fade"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/multi-monitor-dev.jpg)` }}
            >
                <div className="container">
                    <div className="hero-side-content">
                        <h1>Web <span className="text-gradient">Development</span></h1>
                        <p>
                            Custom websites and web applications built with cutting-edge technologies
                            for optimal performance, security, and user experience.
                        </p>
                    </div>
                </div>
            </section>

            {/* Services Section */}
            <section className="section">
                <div className="container">
                    <div className="section-header">
                        <h2>What We <span className="text-gradient">Offer</span></h2>
                        <p>Comprehensive web development solutions for businesses of all sizes</p>
                    </div>
                    <div className="services-grid">
                        {services.map((service, index) => (
                            <div key={index} className="card card-gradient service-card">
                                <div className="service-icon">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Feature Row */}
            <div className="image-feature-row reverse">
                <div
                    className="feature-img"
                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/web-dev-macbook.jpg)` }}
                />
                <div className="feature-body">
                    <h3>Built for <span className="text-gradient">Performance</span></h3>
                    <p>Every line of code is optimized for speed, accessibility, and scalability. We build with modern frameworks and test across devices before anything ships.</p>
                </div>
            </div>

            {/* Process Section */}
            <section className="section">
                <div className="container">
                    <div className="section-header">
                        <h2>Our <span className="text-gradient">Process</span></h2>
                        <p>A proven approach to delivering exceptional results</p>
                    </div>
                    <div className="services-grid">
                        {workProcess.map((item, index) => (
                            <div key={index} className="card card-gradient" style={{ textAlign: 'left' }}>
                                <span
                                    className="text-gradient"
                                    style={{ fontSize: '2.5rem', fontWeight: '800' }}
                                >
                                    {item.step}
                                </span>
                                <h3 style={{ margin: '1rem 0 0.5rem' }}>{item.title}</h3>
                                <p className="text-muted">{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="section">
                <div className="container">
                    <div className="cta-section">
                        <div className="cta-content">
                            <h2>Ready to Build Your Website?</h2>
                            <p>
                                Let's discuss your project and create something amazing together.
                            </p>
                            <Link to="/contact" className="btn btn-primary">
                                Start Your Project →
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default WebDevelopment;
